// extracted by mini-css-extract-plugin
export var center = "_4q-2";
export var clickableRow = "_4q-5";
export var expandedRow = "_4q-7";
export var hoverable = "_4q-4";
export var left = "_4q-1";
export var right = "_4q-3";
export var row = "_4q-0";
export var selectedRow = "_4q-6";
export var summaryRow = "_4q-8";